import { ref, type Ref } from 'vue';
import type { MaskInputOptions } from 'maska';

export const useMaska = () => {
	const phoneMaskaOptions: Ref<MaskInputOptions> = ref({
		preProcess(value: string): string {
			function formatPhoneNumber(input: string): string {
				// check if 1 is the first digit in the parentheses(can occur when user uses autofill)
				if (input.startsWith('(') && input.charAt(1) === '1') {
					input = input.replace(input[1]!, '');
				} else if (input.startsWith('1')) {
					input = input.replace(input[0]!, '');
				}

				return input;
			}

			return formatPhoneNumber(value);
		},
		mask: '(###) ###-####'
	});

	return { phoneMaskaOptions };
};
